const endpoints = {
    vocales:'/vocales',
    elecciones:'/elecciones',
    glosas:'/vocales/glosas',
    // exportTeacherList:'/user/teachers/export'
}
export {endpoints}
